"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.reports", {
      url: "users",
      views: {
        main: {
          templateUrl: "/modules/Commom/reports/views/reports.users.html",
          controller: "reportsUsersCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
